import { getApiUrl } from '../../utils/config';

export const backendApi = getApiUrl() || 'http://localhost:3002/api';



// WEBPACK FOOTER //
// ./src/services/api/config.ts